import createVueApp from '@/common/createApp'

// Styxie derives name from Admin::PricingCalculatorController → AdminPricingCalculator
Styxie.Initializers.AdminPricingCalculator = {
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/admin/pricing_calculator/index.vue')
    createVueApp(ShowPage, { props })
  }
}
